// Remplace l'évaluation globale de compatibilité d'un animal (compatibilityEvaluation
// + compatibilities) par une évaluation par cible (compatibilityEvaluations), une
// ligne par Compatibility de type human / animal :
// - global Oui        -> cibles cochées = Oui, autres = Non évaluée
// - global Non        -> toutes les cibles = Non
// - Non évaluée / vide -> toutes les cibles = Non évaluée
// Les animaux déjà migrés (compatibilityEvaluations présent) sont ignorés.

const YES = '1'
const NO = '2'
const NOT_EVALUATED = '3'

function evaluationFor(animal, target) {
    if (animal.compatibilityEvaluation === NO) return NO
    if (animal.compatibilityEvaluation !== YES) return NOT_EVALUATED
    const compatibilities = (animal.compatibilities || []).map(id => id.toString())
    return compatibilities.includes(target._id.toString()) ? YES : NOT_EVALUATED
}

async function applyJob() {
    const animalCollection = global.app.C.Animal.collection
    const evaluationCollection = global.app.C.AnimalCompatibilityEvaluation.collection
    const compatibilityCollection = global.app.C.Compatibility.collection

    const animals = await animalCollection.find({compatibilityEvaluations: {$exists: false}}).toArray()
    if (!animals.length) return {message: "Aucun animal à adapter"}

    const targets = await compatibilityCollection.find({type: {$in: ['human', 'animal']}}).toArray()
    const targetsByGroup = new Map()
    targets.forEach(target => {
        const group = target.group?.toString()
        if (!targetsByGroup.has(group)) targetsByGroup.set(group, [])
        targetsByGroup.get(group).push(target)
    })

    const evaluations = []
    const operations = animals.map(animal => {
        const rows = (targetsByGroup.get(animal.group?.toString()) || []).map(target => ({
            _id: new global.ObjectID(),
            compatibility: target._id,
            evaluation: evaluationFor(animal, target),
            animal: animal._id,
            group: animal.group
        }))
        evaluations.push(...rows)
        return {
            updateOne: {
                filter: {_id: animal._id},
                update: {
                    $set: {compatibilityEvaluations: rows.map(row => row._id)},
                    $unset: {compatibilityEvaluation: '', compatibilities: ''}
                }
            }
        }
    })

    if (evaluations.length) await evaluationCollection.insertMany(evaluations)
    const result = await animalCollection.bulkWrite(operations)
    return {message: `${result.modifiedCount} animal(aux) adapté(s), ${evaluations.length} évaluation(s) de compatibilité créée(s)`}
}

export const job = {
    name: "adaptAnimalCompatibilities",
    title: "Adapter les compatibilités des animaux (évaluation par cible)",
    execute: function(context, callback) {
        applyJob()
            .then(result => callback(null, result))
            .catch(callback)
    }
}
